import { Mark } from '../../components/Mark'
import { WRITING_PUBLIC } from './writing'

/*
  The marketing site's masthead and footer.

  Their own file so the homepage and the writing archive can both use them without one
  importing the other. Landing imports Blog for the archive; if the archive then imported
  the masthead back out of Landing, that is a cycle.
*/

export function Masthead() {
  return (
    <header className="l-mast">
      <div className="l-mast__in">
        <a className="l-lockup" href="/" aria-label="Boardium">
          <Mark className="l-lockup__mark" />
          <img className="l-lockup__word" src="/brand/wordmark-ink.png" alt="Boardium" />
        </a>
        <nav className="l-mast__nav">
          <a href="/why/">Why Boardium</a>
          <a href="/#argues">How it argues</a>
          <a href="/#cost">What it costs</a>
          {WRITING_PUBLIC && <a href="/blog/">Writing</a>}
          <a className="l-btn l-btn--gold" href="/#signin">Sign in</a>
        </nav>
      </div>
    </header>
  )
}

export function Foot() {
  return (
    <footer className="l-foot">
      <div className="l-wrap l-foot__in">
        <a className="l-lockup" href="/" aria-label="Boardium">
          <Mark className="l-lockup__mark" />
          <img className="l-lockup__word" src="/brand/wordmark-ink.png" alt="Boardium" />
        </a>
        <p>boardium.co</p>
      </div>
    </footer>
  )
}
